<template>
  <b-modal
    id="modal-scoped"
    ref="modal-scoped"
    no-close-on-backdrop
    hide-footer
    :visible="showModalLogin"
    cancel-disabled
    centered
    @close="closeModal"
    @hide="closeModal"
    data-cy="modal-login-principal"
  >
    <template slot="modal-header" slot-scope="{ close }">
      <div
        class="d-flex flex-column align-items-center w-100"
        data-cy="modal-login-header"
      >
        <font-awesome-icon
          style="position: absolute; right: 16px; cursor: pointer"
          @click="close"
          icon="times"
          data-cy="modal-login-btn-fechar"
        ></font-awesome-icon>
        <h4
          class="text-primary font-weight-bold mb-0"
          data-cy="modal-login-titulo"
        >
          Identifique-se
        </h4>
        <small data-cy="modal-login-subtitulo"
        >Para continuar, precisamos de algumas informações suas</small
        >
      </div>
    </template>
    <template slot="default">
      <div class="d-flex flex-column" data-cy="modal-login-conteudo">
        <div
          class="card-body p-lg- 5 d-flex flex-column"
          data-cy="modal-login-body"
        >
          <div class="card p-3" data-cy="modal-login-card-social">
            <div
              class="d-flex flex-column align-items-center w-100 mb-2"
              data-cy="modal-login-social-header"
            >
              <h4
                class="text-primary font-weight-bold mb-0"
                data-cy="modal-login-social-titulo"
              >
                Continue com
              </h4>
            </div>
            <div
              class="d-flex flex-row justify-content-center"
              data-cy="modal-login-social-botoes"
            >
              <button
                type="button"
                @click="authenticate('facebook')"
                class="btn btn-lg text-nowrap btn mr-3"
                data-cy="btn-login-facebook"
                style="background-color: #3b5796; color: white;"
              >
                <font-awesome-icon
                  class="mr-lg-2"
                  :icon="['fab', 'facebook-square']"
                  data-cy="btn-login-facebook-icon"
                />
                Facebook
              </button>
              <button
                type="button"
                @click="authenticate('google')"
                class="btn btn-lg text-nowrap btn"
                data-cy="btn-login-google"
                style="background-color: #e74a4a; color: white;"
              >
                <font-awesome-icon
                  class="mr-lg-3"
                  :icon="['fab', 'google']"
                  data-cy="btn-login-google-icon"
                />
                Google
              </button>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-lg text-nowrap btn-primary px-0 mt-3 mb-3"
            data-cy="btn-cadastrar-se"
            @click="toSignUp()"
          >
            Cadastre-se
          </button>
          <small
            class="font-weight-bold text-center mb-2"
            data-cy="modal-login-separador"
          >OU</small
          >
          <form action="logon" method="post" data-cy="form-login">
            <b-alert
              show
              variant="danger"
              class="alert-dismissible mb-1 p-1"
              v-if="error"
              data-cy="alert-erro-login"
            >{{ error }}</b-alert
            >
            <div class="d-flex flex-column" data-cy="campo-usuario-container">
              <small
                class="font-weight-bold text-muted"
                data-cy="campo-usuario-label"
              >Usuário</small
              >
              <!-- Actual search box -->
              <div class="form-group mb-0" data-cy="campo-usuario-form-group">
                <input
                  type="text"
                  class="form-control rounded-0"
                  id="user"
                  name="user"
                  placeholder="Usuário ou email"
                  v-model="username"
                  data-cy="campo-usuario-input"
                />
              </div>
            </div>
            <div
              class="d-flex flex-column mt-3"
              data-cy="campo-senha-container"
            >
              <small
                class="font-weight-bold text-muted"
                data-cy="campo-senha-label"
              >Senha</small
              >
              <!-- Actual search box -->
              <div class="form-group mb-0" data-cy="campo-senha-form-group">
                <input
                  type="password"
                  class="form-control rounded-0"
                  id="password"
                  placeholder="Senha"
                  name="password"
                  v-model="password"
                  data-cy="campo-senha-input"
                />
              </div>
            </div>
            <small
              class="text-center btn-link cursor"
              style="color:#29b891"
              @click="toRecoverPassword()"
              data-cy="link-esqueceu-senha"
            >
              Esqueceu a senha?
            </small>
            <b-form-checkbox
              id="cb-login"
              class="mt-3"
              v-model="aceitaPoliticas"
              name="cb-login"
              data-cy="checkbox-aceita-politicas"
            >
              Eu concordo com a
              <a
                target="_blank"
                :href="urls.politicaPrivacidadeLink"
                data-cy="link-politica-privacidade"
              >
                Política de Privacidade
              </a>
              e com o
              <a
                target="_blank"
                :href="urls.termoUsoLink"
                data-cy="link-termo-uso"
              >
                Termo de Uso
              </a>
            </b-form-checkbox>
            <input
              @click.prevent="submit"
              value="Continuar"
              type="submit"
              class="btn btn-primary btn-lg d-flex justify-content-center align-items-center mb-2 w-100 mt-3"
              data-cy="btn-submit-login"
            />
          </form>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { axiosInstance as Axios } from "@/main";
import Store from "@/store";

export default {
  name: "modal-user-login",
  directives: {},
  data() {
    return {
      username: null,
      password: null,
      loading: false,
      error: null,
      aceitaPoliticas: false
    };
  },
  computed: {
    showModalLogin() {
      return this.$store.getters.show_modalLogin;
    },
    actual() {
      return this.$store.getters.actual;
    },
    go() {
      return this.$store.getters.to;
    },
    user() {
      return this.$store.getters.user;
    },
    to() {
      return this.$store.getters.to;
    },
    urls() {
      return this.$store.getters.urls;
    }
  },
  methods: {
    async authenticate(method) {
      try {
        // XXX: importante caso o usuário acesse utilizando alguns navegadores imbutidos de alguns apps (como instagram)
        sessionStorage.setItem(
          "mol.oauthMethod",
          method
        );

        let response =
          await this.$auth.authenticate(method);

        let resp;

        try {
          resp = await Axios.post(
            `/social/auth/${method}`,
            {
              ...response
            }
          );
        } catch (e) {
          return;
        }

        let payload = {
          url: this.$serverHost,
          token: resp.data.token,
          organizationId:
          this.$route.params.organizationId,

          redirect: () => {
            if (this.go) {
              this.$router.push(
                this.go
              );
            } else if (this.actual) {
              this.$router.push(
                this.actual
              );
            } else {
              this.$router.push({
                name: "consulta_convenio",
                params: {
                  organizationId:
                  this.$route.params.organizationId
                }
              });
            }

            this.loading = false;
          }
        };

        await this.$store.dispatch(
          "login_social",
          payload
        );
      } catch (e) {
        console.log(e);
      }
    },
    async submit() {
      this.loading = true;

      if (!this.aceitaPoliticas) {
        this.error =
          "É necessário informar que concorda com a Política de Privacidade e com os Termos de Uso para realizar o login.";
        return;
      }

      let payload = {
        url: this.$serverHost,
        email: this.username,
        senha: this.password,
        organizationId: this.$route.params.organizationId
      };
      try {
        await this.$store.dispatch("login", payload);
      } catch (e) {
        console.log(e);
        this.error = "Usuário ou Senha Inválidos";
        return;
      }

      this.$router.push(this.to);
    },
    closeModal() {
      this.error = null;
      this.username = null;
      this.password = null;
      this.aceitaPoliticas = false;
      this.loading = false;
      this.$store.dispatch("set_modalLogin", false);
    },
    toSignUp() {
      this.error = null;
      this.username = null;
      this.password = null;
      this.loading = false;
      Store.dispatch("set_to", this.to);
      this.$store.dispatch("set_modalLogin", false);
      this.$store.dispatch("set_modalRecoverPassword", false);
      this.$store.dispatch("set_modalSignUp", true);
    },
    toRecoverPassword() {
      this.error = null;
      this.username = null;
      this.password = null;
      this.loading = false;
      Store.dispatch("set_to", this.to);
      this.$store.dispatch("set_modalLogin", false);
      this.$store.dispatch("set_modalSignUp", false);
      this.$store.dispatch("set_modalRecoverPassword", true);
    }
  }
};
</script>
